module.exports = __webpack_public_path__ + "img/swiper_1.683585f0.png";